// extracted by mini-css-extract-plugin
export var bubble = "_r-0";
export var container = "_r-f";
export var contrastBorder = "_r-g";
export var greyOut = "_r-2";
export var initialsColor0 = "_r-3";
export var initialsColor1 = "_r-4";
export var initialsColor10 = "_r-d";
export var initialsColor11 = "_r-e";
export var initialsColor2 = "_r-5";
export var initialsColor3 = "_r-6";
export var initialsColor4 = "_r-7";
export var initialsColor5 = "_r-8";
export var initialsColor6 = "_r-9";
export var initialsColor7 = "_r-a";
export var initialsColor8 = "_r-b";
export var initialsColor9 = "_r-c";
export var initialsWrapper = "_r-1";
export var large = "_r-l";
export var medium = "_r-k";
export var mediumSmall = "_r-j";
export var mediumSmallMedium = "_r-o";
export var micro = "_r-h";
export var small = "_r-i";
export var tiny = "_r-n";
export var xTiny = "_r-m";